import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { USER } from '../constants/LocalStorageOptions';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem(USER)
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )} />
)